import React, {  useEffect, useState,useContext  } from "react";

import Lang from '../lang/translations';

import Context from '../context/context';
import ReactGA from 'react-ga4';
import FormUniversale  from './forms/form_universale';

import Paypal from './forms/paypal/paypal';
import Adyen_ApplePay from './forms/adyen_apple_pay/apple_pay';
import Adyen_GooglePay from './forms/adyen_google_pay/google_pay';
import Shift4_ApplePay from './forms/shift4_aple_pay/apple_pay';

import Mollie from './forms/mollie/mollie';
import Coda from './forms/coda/coda';

import { GTMEvents } from '../_helpers/gtm/gtm';

import helpers from "../_helpers/helpersFunction";

import * as config from "../_helpers/configServizi";

export default function PaymentPage(props) { 

    const  context = useContext(Context)
    const [metodiPagamento, setmetodiPagamento] = useState(true);
    const domain = window.location.hostname;

    useEffect(() => {
		window.scrollTo({top: 0, behavior: 'smooth'});

	});

    useEffect(() => {
        helpers.logToBackend("Pixel init checkout",{pixel:true,clickid:localStorage.getItem('trackerId'),et:"initiate_checkout"})
        helpers.kpiPanel(context, "initiate_checkout", null, true, null, { canon: "view_checkout", dedup: true });
        GTMEvents.initiate_checkout(localStorage.getItem("trackerId"),context.email,window.location.hostname)
    },[]);


    function HeaderFormPagamento(){

        if (context.fluxId === "0000") {
            return (<>
                <div className="headerForm">
                    <div className="w85 align-center pl5">
                        <h3> <strong>{context.rateplanScelto.nomePiano}</strong><span style={{ fontSize: "0.7em" }}> / {context.rateplanScelto.prezzo}</span></h3>
                        <h4><strong>{context.rateplanScelto.badge}</strong></h4>
                    </div>
                </div>
                </>            
            )
        }
       
        if(context.flusso.verificaEta && context.premiumLevel === 0){
            return (
                <div>
                    <div className="headerForm">
                        <div className="iconPayment w15 align-center">
                            <img src="/img/check-blue.png"/>
                        </div>
                        <div className="w85 align-center pl5"> 
                            <h3 className="verificaeta"><Lang w={"procedura"} page={"payment_page"}/></h3>
                        </div>
                    </div>
                    <div className="subHeaderForm w100 align-center">
                        <small><Lang w={"nessun_addebito"} page={"payment_page"}/></small>
                        <small><Lang w={"inserisci_e_verifica"} page={"payment_page"}/></small>
                    </div>
                </div>
            )
        }else{
            return (<>
                <div className="headerForm">
                  
                    
                {!metodiPagamento && ( <div className="w85 align-center pl5"> 
                        <h3> <strong>{context.rateplanScelto.nomePiano}</strong><span style={{fontSize:"0.7em"}}> / {context.rateplanScelto.prezzo}</span></h3> 
                        <h4><strong>{context.rateplanScelto.badge}</strong></h4>
                        <div class="guarantee-box mb-0  mt-4  pb-4">
                            <div class="guarantee-header-full ">
                                <div class="d-flex justify-content-center align-items-center">
                                    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 64 64"  width="36" height="36" fill="#4cb050">
                                        <rect class="st0" width="64" height="64"></rect><g><path class="st1" style={{fill:"#FFFFFF"}} d="M51,32l-4.2-4.8l0.6-6.4l-6.2-1.4l-3.3-5.5L32,16.4l-5.9-2.5l-3.3,5.5l-6.2,1.4l0.6,6.4L13,32l4.2,4.8 l-0.6,6.4l6.2,1.4l3.3,5.5l5.9-2.5l5.9,2.5l3.3-5.5l6.2-1.4l-0.6-6.4L51,32z M28.7,40.2l-6.6-6.6l2.6-2.6l4,4l10.1-10.1l2.6,2.6 L28.7,40.2z"></path></g>
                                    </svg>
                                    <Lang w={"garanzia_di_rimborso"} page={"payment_page"}/>
                                </div>
                            </div>
                            <div class="guarantee-body ">
                                <div>
                                    <Lang w={"garanzia_di_rimborso_text"} page={"payment_page"}/>
                                    
                                </div>
                                </div>
                            </div>
                        {/*context.paymentPageText.text1 !== "non_paghi_nulla" && (  <p>{Lang( {"w": "stai_acquistando" ,"page": "payment_page"})} : <strong>{context.rateplanScelto.nomePiano + " - " +  context.rateplanScelto.prezzo}</strong></p>)*/}
                        
                </div>)}

                {metodiPagamento && ( <div className="w85 align-center pl5"> 
                        
                        <h4 style={{marginTop:"30px"}} ><strong><Lang w={"attiva_pass"} page={"payment_page"}/></strong></h4>
                       
                        {/*context.paymentPageText.text1 !== "non_paghi_nulla" && (  <p>{Lang( {"w": "stai_acquistando" ,"page": "payment_page"})} : <strong>{context.rateplanScelto.nomePiano + " - " +  context.rateplanScelto.prezzo}</strong></p>)*/}
                        
                </div>)}
                    

                  
            
                </div>
                  
                  </>
            )
        }
       
    }


    function Sistemi_di_pagamento() {
        console.log("payment page", context.flusso.sistemi_pagamento);
      
        return (
          <>
            {context.flusso.sistemi_pagamento.map((sistema, index) => {
          
              if(sistema === "credit_card"){
                return  buttonCreditCard()
              }
              if (sistema === "paypal") {
                return <Paypal key={index} />;
              }
              if (sistema === "applepay") {
                return <Adyen_ApplePay key={index} />;
              }
              if (sistema === "googlepay") {
                return <Adyen_GooglePay key={index} />;
              }
                if (sistema === "shift4_applepay") {
                return <Shift4_ApplePay key={index} />;
              }
              if (sistema === "mollie") {
                return <Mollie key={index} />;
              }

              if (sistema === "coda_paypal") {
                return <Coda key={index} />;
              }
              
              return null; // Or some other default component if needed
            })}

            
            
          </>
        );
      }


    
    function buttonCreditCard(){
        return (<>
             <button className="btn btn-block choose" onClick={()=>{setmetodiPagamento(false); }}><div>{Lang( {"w": "carta","page": "creditCardForm"} )}<img style={{marginLeft:"10px"}} src="/img/method_hpp.png"></img></div></button>
        </>)
    }
    

    return (<div className="all-container bg-light puchasePage">
         
        <div className="container filters-no-padding" role="main">
            <div className="row">
                    
                    <div className="col-md-7 col-12 col-centered">
                        <HeaderFormPagamento/>
                                <>
                                    {context.paymentPageText.text1 && (
                                        <div className="testo_payment">
                                            <p>{Lang( {"w": context.paymentPageText.text1 ,"page": "payment_page"} )}</p>
                                        </div>
                                    )}
                                    
                                    {metodiPagamento && (<h3 style={{textAlign:"center",fontSize:"1em",marginTop:"20px"}}>{Lang( {"w": "scegli_metodo" ,"page": "payment_page"} )}</h3>)}
                                    
                                    <div style={metodiPagamento ? ({marginTop: "40px", backgroundColor: "#eee",padding: "20px",borderRadius: "10px"}) : ({marginTop: "0px"})}>
                                    
                                        <FormUniversale form_invisibile={metodiPagamento} />
                                    
                                    {metodiPagamento && (<>
                                        
                                        <Sistemi_di_pagamento/>
                                        {context.flusso.sistemi_pagamento.includes("coda_paypal") && (<small><Lang w={"coda_discplaimer"} page={"payment_page"}/></small>)}

                                    {(window.location.hostname === "jammydate.com" && context.fluxId === "0000") && (
                                                <div className="text-center">
                                        <span className="piccolino">{config.servizi[domain].company_name + " " + config.servizi[domain].company_address}</span>
                                                </div>
                                        )}
                                    </>)}
                                </div>
                                   
                                       
                                </>    
                    </div>
                </div>
            </div>
       </div>
            )

}